import { useEffect } from 'react';

const useOutsideClick = (ref, callback) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  const handleEscClick = (event) => {
    if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
      callback();
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleEscClick)

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleEscClick)
    };
  });
};

export default useOutsideClick;
